import React, { useState, useEffect } from 'react';
import Modal from './Modal';

function InternalWorkModal({ isOpen, onClose, date, clockInTime, clockOutTime, existingRecord, onSubmit }) {
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [breakTime, setBreakTime] = useState('0');
  const [note, setNote] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // 既存の記録がある場合は、フォームに値をセット
  useEffect(() => {
    if (existingRecord) {
      setStartTime(existingRecord.start_time.substring(0, 5));
      setEndTime(existingRecord.end_time.substring(0, 5));
      setBreakTime(existingRecord.break_time.toString());
      setNote(existingRecord.note || '');
    } else {
      // 新規の場合は、出勤時間をデフォルト値にする
      setStartTime(clockInTime || '');
      setEndTime('');
      setBreakTime('0');
      setNote('');
    }
  }, [existingRecord, clockInTime]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // 入力値の検証
    if (!startTime || !endTime) {
      setError('開始時間と終了時間は必須です');
      return;
    }

    if (startTime >= endTime) {
      setError('開始時間は終了時間より前である必要があります');
      return;
    }

    // 出勤・退勤時間の範囲内かチェック
    if (clockInTime && startTime < clockInTime) {
      setError(`開始時間は出勤時間（${clockInTime}）以降である必要があります`);
      return;
    }

    if (clockOutTime && endTime > clockOutTime) {
      setError(`終了時間は退勤時間（${clockOutTime}）以前である必要があります`);
      return;
    }

    try {
      setLoading(true);
      
      // 親コンポーネントの送信ハンドラを呼び出す
      await onSubmit({
        date,
        startTime,
        endTime,
        breakTime: parseInt(breakTime, 10) || 0,
        note
      });
      
      onClose();
    } catch (err) {
      console.error('社内業務申請エラー:', err);
      setError(err.message || '社内業務申請の送信に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="社内業務時間登録">
      <div className="p-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-3">
              日付
            </label>
            <div className="p-3 bg-gray-100 rounded border">
              {date}
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-3">
              開始時間
            </label>
            <input
              type="time"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
              required
            />
            {clockInTime && (
              <p className="text-xs text-gray-500 mt-2 pl-1">
                参考: 出勤時間 {clockInTime}
              </p>
            )}
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-3">
              終了時間
            </label>
            <input
              type="time"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
              required
            />
            {clockOutTime && (
              <p className="text-xs text-gray-500 mt-2 pl-1">
                参考: 退勤時間 {clockOutTime}
              </p>
            )}
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-3">
              休憩時間（分）
            </label>
            <input
              type="number"
              min="0"
              value={breakTime}
              onChange={(e) => setBreakTime(e.target.value)}
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
              placeholder="0"
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-3">
              備考
            </label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500 resize-none"
              rows="3"
              placeholder="作業内容等を記入してください"
            />
          </div>

          {error && (
            <div className="mb-6 p-3 bg-red-50 border border-red-200 rounded text-red-600 text-sm">
              {error}
            </div>
          )}

          <div className="flex justify-end pt-4">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-3"
            >
              キャンセル
            </button>
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              disabled={loading}
            >
              {loading ? '送信中...' : '登録'}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default InternalWorkModal; 